<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild container">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <!-- 头部顶部容器 -->
      <div class="container t-container">
        <router-link to="/index" class="main-logo fll">
          <img src="../../../static/images/logo.png"  alt="">
        </router-link>
        <div class="classify fll">
          <div class="cate">
            <span @click="listJump(goodsList[0].id)">机器人 <i class="el-icon-caret-bottom"></i></span>
            <div class="cate-box">
              <ul>
                <li class="cate-item" @click="detailJump(item.id)" v-for="item in goodsList[0].child" :key="item.key">
                  <p>{{item.name}}</p>
                  <img :src="item.pathS" alt="">
                </li>
              </ul>
            </div>
          </div>
          <div class="cate">
            <router-link to="/news">新闻中心</router-link>
          </div>
          <div class="cate">
            <router-link to="/server">技术动态</router-link>
          </div>
          <!-- <div class="cate">
            <span @click="listJump(goodsList[1].id)">电气监测 <i class="el-icon-caret-bottom"></i></span>
            <div class="cate-box">
              <ul>
                <li class="cate-item" @click="detailJump(item.id ,false)" v-for="item in goodsList[1].child" :key="item.key">
                  <p>{{item.name}}</p>
                  <img :src="item.path" alt="">
                </li>
              </ul>
            </div>
          </div> -->
          <!--<router-link to="/product/a">机器人</router-link>-->
          <!--<router-link to="/product/b">电气监测</router-link>-->
        </div>
        <div class="flr">
          <el-tooltip class="item"  placement="bottom-start"  effect="light">
            <div slot="content" style="line-height: 18px">吴经理：13813566659</div>
            <span class="tb-icon" style="background-position:-42px 0;"></span>
          </el-tooltip>
          <el-tooltip class="item" content="2853381003" placement="bottom-start"  effect="light">
            <span class="tb-icon" style="background-position:-42px -36px;"></span>
          </el-tooltip>
          <el-tooltip class="item" placement="bottom-start"  effect="light">
            <div slot="content"><img src="../../../static/images/wx_fw_ewm.jpg" alt=""></div>
            <span class="tb-icon" style="background-position:-42px -72px;"></span>
          </el-tooltip>
          <el-tooltip class="item"  effect="light" content="189 2103 8353" placement="bottom-start">
            <span class="tb-icon" style="background-position:-42px -111px;"></span>
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <!--<div class="header-nav hidden-xs">-->
      <!--&lt;!&ndash; 导航内容 &ndash;&gt;-->
      <!--<div class="container">-->
        <!--<ul class="header-nav-wrapper">-->
          <!--<li><router-link to="/index">首页</router-link></li>-->
          <!--<li class="product-s" @mouseover="overFun" @mouseleave="leaveFun">-->
            <!--<router-link to="/product/a">产品中心</router-link>-->
            <!--<v-classify ></v-classify>-->
          <!--</li>-->
          <!--<li><router-link to="/plan">技术论坛</router-link></li>-->
          <!--<li><router-link to="/server">技术动态</router-link></li>-->
          <!--<li><router-link to="/news">技术动态</router-link></li>-->
          <!--<li><router-link to="/about">关于盈能</router-link></li>-->
        <!--</ul>-->
      <!--</div>-->
    <!--</div>-->
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <router-link to="/index" class="main-logo fll">
          <img src="../../assets/images/logo.png"  alt="">
        </router-link>
        <van-cell is-link @click="showPopup" class="el-icon-menu" >
        </van-cell>
      </div>
      <div style="clear: both;"></div>
      <van-popup v-model="show"
                 position="top"
                 :style="{ height: '40%' }"
                 get-container="body"
      >
        <van-cell-group>
          <van-cell title="首页" @click="hidePopup" is-link to="/index" />
          <van-cell title="智能巡检机器人" />
          <div class="secondary">
            <ul class="secondary-list">
              <li v-for="item in goodsList[0].child" @click="detailJump(item.id,true)"><router-link tag="p"  to="/product/a">{{item.name}}<van-icon name="arrow" /></router-link> </li>

            </ul>
          </div>
          <!-- <van-cell title="电气监测" />
          <div class="secondary">
            <ul class="secondary-list">
              <li v-for="item in goodsList[1].child" @click="detailJump(item.id,true)"><router-link tag="p"  to="/product/a">{{item.name}}<van-icon name="arrow" /></router-link> </li>

            </ul>
          </div> -->
          <van-cell title="技术动态" @click="hidePopup" is-link to="/server" />
          <van-cell title="新闻中心" @click="hidePopup" is-link to="/news" />
        </van-cell-group>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import Goods from '../../assets/data/goods-list.js';
  import vClassify from '../public/classify';

  export default {
      data(){
        return{
          show:false,
          goodsList:[]
        }
      },
      name: "Header",
      created() {
        this.goodsList = Goods.goods;
      },
      methods:{
        overFun(){
          this.$store.commit('set_true');
        },
        leaveFun(){
          this.$store.commit('set_false');
        },
        listJump(path){
          this.$router.push({
            name: 'product',
            params:{
              id:path
            }
          })
        },
        showPopup() {
          this.show = true;
        },
        hidePopup(){
          this.show = false;
        },
        detailJump(path,mob){
          if(mob){
            this.show = false;
          }
          this.$router.push({
            name: 'product-detail',
            params:{
              id:path
            }
          })
        }
      },
    components:{
        vClassify
      }
    }
</script>

<style scoped lang="less">
  #header.container{
    padding-left: 0!important;
    padding-right: 0!important;
  }
#header{
  box-shadow: 0 0 10px rgba(0,0,0,0.2);
  width: 100%;
  position: relative;
  .t-container{
    padding: 22px 0;
    .main-logo{
      display: inline-block;
      width: 110px;
      height: 26px;
      margin-right: 120px;
      img{
        width: 100%;
      }
    }
    .classify{
      font-size: 15px;
      .cate{
        display: inline-block;
        cursor: pointer;
        margin-right: 40px;
        line-height: 25px;
        text-decoration: none;
        padding-bottom: 17px;
        span{
          font-size: 15px;
        }
        a{
          color: #000;
        }
        a:hover{
          text-decoration: none;
        }
        .cate-box{
          width: 100%;
          height: 0;
          opacity: 0;
          z-index: 99;
          position: absolute;
          top: 70px;
          left: 0;
          background-color: #ffffff;
          transition: all 0.3s ease;
          overflow: hidden;
          border: 1px solid #eeeeee;
          ul{
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-bottom: 0;
          }
          .cate-item{
            padding-top: 30px;
            text-align: center;
            width: 279px;
            line-height: 0;
            display: block;
            transition: all 0.3s ease;
            border-right: 1px solid #dddddd;
            &:hover{
              text-decoration: underline;
            }
            &:last-child{
              border-right: none;
            }
            p{
              margin-bottom: 18px;
              font-size: 15px;
              line-height: 15px;
            }
            img{
              width: 100%;
              height: 205px;
            }
          }

        }
        &:hover{
          color: #002e60;
          border-bottom: 3px solid #002e60;
          .cate-box{
            height: 269px;
            opacity: 1;
            z-index: 9999;
          }
          .cate-item{
            color:#333333;
          }
        }
      }

    }
    .flr{
      margin-top: 1px;
      color: #999999;
      display: flex;
      flex-direction: row;
      .tb-icon{
        width: 24px;
        height: 24px;
        background: url('../../../static/images/icon/tb.png') no-repeat;
      }
      .el-tooltip{
        margin-left: 22px;
      }
    }
  }
  .header-nav{
    width: 100%;
    background-color: #004ca0;
    height: 35px;
    .container{
      background-color: #004ca0;
      height: 100%;
      .header-nav-wrapper{
        li{
          cursor: pointer;
          line-height: 35px;
          color:#ffffff;
          padding: 0;
          transition: all 0.2s ease;
          display: inline-block;
          &:hover{
            background-color: #002e60;
          }
          a{
            padding: 0 20px;
            display: block;
            width: 100%;
            height: 100%;
            color:#ffffff;
            text-decoration: none;
            &:hover{
              text-decoration: none;
            }
          }
        }
        .product-s{
          position: relative;
          .pos-box{
            color: #333333;
            padding: 18px;
            position: absolute;
            top:35px;
            left: 0;
            width: 450px;
            height: auto;
            background-color: #fff;
            border: 1px solid #CCCCCC;
            transition: all 0.3s;
            z-index:998;
            div{
              height: auto;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            dl{
              width: 125px;
              margin-right: 20px;
              &:nth-child(3n){
                margin-right: 0;
              }
              dt{
                color:#002e60;
              }
              dd{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 12px;
                &:hover{
                  text-decoration: underline;
                }
              }
            }
          }

        }
      }
    }
  }
  .header-nav-m{
    border-bottom: 1px solid #999999;
    .header-nav-m-logo{
      .main-logo{
        padding: 10px 0;
        img{
          height: 100%;
        }
      }
    }
    .el-icon-menu{
      float: right;
      font-size: 28px;
      width: 60px;
      color: #666666;
      text-align: center;
      line-height: 50px;
      margin-right: 16px;
      .van-cell__right-icon{
        display: none;
      }
    }

  }
}
.van-popup--top{
  top:70px;
  .secondary{
    margin-left: 16px;
    border-bottom: 1px solid #ebedf0;
    ul{
      li{
        height: 36px;
        padding: 10px 16px ;
        p{
          cursor: pointer;
          line-height: 16px;
          margin-bottom: 0;
          i{
            float: right;
            line-height: 26px;
          }
        }
      }
    }
  }
}
@media (min-width: 1000px) {
  #header{
    min-width: 1400px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/public/header.vue